import * as React from "react";

const SvgConvertEe = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.29 10.48a9.2 9.2 0 0 0-1.92-2.85 9.1 9.1 0 0 0-2.85-1.92C14.43 5.23 13.26 5 12.01 5h-.15l1.55-1.55L12.01 2l-4 4 4 4 1.4-1.45L11.86 7h.15c1.95 0 3.6.68 4.96 2.04s2.04 3.01 2.04 4.96-.68 3.6-2.04 4.96S13.96 21 12.01 21s-3.6-.68-4.96-2.04S5.01 15.95 5.01 14H3c0 1.25.24 2.42.71 3.51a9.3 9.3 0 0 0 1.93 2.85 9.1 9.1 0 0 0 2.85 1.92c1.09.48 2.26.71 3.51.71s2.42-.24 3.51-.71a9.2 9.2 0 0 0 2.85-1.92c.81-.8 1.45-1.76 1.92-2.85.48-1.09.71-2.26.71-3.51s-.24-2.42-.71-3.51zm-8.91 5.46H9.25v-1.55h1.99v-1.04H9.25v-1.32h2.13v-1.04H8v6h3.38zM16 10.99v1.04h-2.14v1.32h1.99v1.04h-1.99v1.55H16v1.05h-3.38v-6z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgConvertEe;
